export const DEV_URL = 'https://api.custom-voice.ggm.kr:9000/';
export const CARD_URL = 'https://api.custom-voice.ggm.kr:9000/';

export default DEV_URL;
